import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import useStravaStats from "../../hooks/useStravaStats";
import "./StravaFooter.css";

const StravaFooter = () => {
  const { totalKm, loading, error } = useStravaStats();
  const profileUrl = process.env.REACT_APP_STRAVA_PROFILE_URL;
  const cardRef = useRef(null);

  const kmDisplay = loading
    ? "..."
    : error || totalKm === null
    ? "?"
    : totalKm.toLocaleString();

  useEffect(() => {
    if (!cardRef.current) return;
    gsap.fromTo(
      cardRef.current,
      { opacity: 0, y: 16 },
      { opacity: 1, y: 0, duration: 0.6, ease: "power2.out" }
    );
  }, []);

  const handleMouseMove = (e) => {
    if (!cardRef.current) return;
    const rect = cardRef.current.getBoundingClientRect();
    cardRef.current.style.setProperty("--x", `${e.clientX - rect.left}px`);
    cardRef.current.style.setProperty("--y", `${e.clientY - rect.top}px`);
  };

  return (
    <div className="strava-footer">
      <div
        className="strava-footer-card"
        ref={cardRef}
        onMouseMove={handleMouseMove}
      >
        <svg className="strava-logo-icon" viewBox="0 0 16 16" aria-hidden="true">
          <path d="M6.731 0 2 9.125h2.788L6.73 5.497l1.93 3.628h2.766zm4.694 9.125-1.372 2.756L8.66 9.125H6.547L10.053 16l3.484-6.875z" />
        </svg>
        <p className="strava-footer-text">
          Fueled by espresso and bad decisions:{" "}
          <svg
            className="strava-run-icon"
            viewBox="0 0 24 24"
            aria-hidden="true"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z" />
            <path d="M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z" />
            <path d="M16 17h4" />
            <path d="M4 13h4" />
          </svg>{" "}
          <a
            href={profileUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="strava-km-link"
          >
            {kmDisplay} km
          </a>{" "}
          completed.
        </p>
      </div>
    </div>
  );
};

export default StravaFooter;
